// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"b98a3a33","433":"2910f985","540":"a913ecc3","595":"972e4050","789":"f4b793af","826":"a7b1f462"}[chunkId] + ".chunk.js";
};